<script>
  import { getContext } from "svelte";
  import { fade } from "svelte/transition";
  import http from "common/http";
  import Modal from "common/components/Modal.svelte";
  import getCsrfToken from "common/utils/getCsrfToken";
  import Tooltip, { tooltip } from "common/components/Tooltip";
  import Close from "common/icons/Close.svelte";

  export let urls = {};
  export let orderItems = [];
  export let subscriptionItemTypes = [];

  const t = getContext("STRINGS");

  let mode = "initial";

  function filterVisibleItems(items, orderItems) {
    return orderItems.filter(({ id }) => items[id] != null);
  }

  // Fill items with default data
  let items = orderItems.reduce((acc, cur) => {
    acc[cur.id] = subscriptionItemTypes[0].id;
    return acc;
  }, {});

  $: visibleOrderItems = filterVisibleItems(items, orderItems);

  function handleSwitchClick() {
    mode = "convert";
  }

  // function handleCloseConfirmConversion({ detail }) {
  //   if (detail === "confirm") {
  //     mode = "convert";
  //   } else {
  //     mode = "initial";
  //   }
  // }

  function handleRemoveItem(id) {
    if (confirm(t("remove_seat_confirm_description"))) {
      delete items[id];
      items = items;
    }
  }

  function saveChanges() {
    if(confirm(t("save_and_continue_confirm_description"))) {
      return http
      .post(urls.transform_event_order_path, {
        items: items,
      })
      .then((res) => {
        window.location.href = res.data.url;
        return res;
      });
    }
  }
</script>

<style>
  .__margin {
    margin: 0.5rem;
  }
</style>

{#if mode == "initial"}
  <p class="my-8">{@html t("confirmation_description")}</p>

  <div class="flex flex-wrap justify-center">
    <button
      type="button"
      class="tc-button __size-small __color-primary __margin"
      on:click={handleSwitchClick}>
      {t("confirm_dialog")}
    </button>

    <a
      class="tc-button __size-small __color-secondary __margin"
      href={urls.edit_order_path}>
      {t("decline_dialog")}
    </a>
  </div>
{:else if mode === "convert"}
  <!--  -->
  <div class="w-full max-w-full mx-auto mb-6 divide-y-2 lg:w-2/3">
    <div class="pt-4 mb-6">
      <div class="flex align-center">
        <i class="t-icon-users t-icon__big pr-3"></i>
        <h2>{t("proposal_title")}</h2>  
      </div>
      <p>{t("proposal_description")}</p>
    </div>
    {#each visibleOrderItems as item (item.id)}
      <div
        class="flex pt-4 mb-4 align-center"
        transition:fade={{ duration: 300 }}>
        <div class="flex-1">
          <div class="text-base font-medium">{item.title}</div>
          <div>
            {#if item.section}
              <span>{t("section")}: {item.section}</span>
            {/if}
            {#if item.row}
              <span>{t("row")}: {item.row}</span>
              <span>{t("seat")}: {item.seat}</span>
            {/if}
          </div>
          <div>
            <span>{t("price")}: {item.price}</span>
          </div>
        </div>
        <div class="flex-1 align-center">
          <select bind:value={items[item.id]} name="" id="">
            {#each subscriptionItemTypes as subscriptionItemType}
              <option value={subscriptionItemType.id}
                >{subscriptionItemType.title}</option>
            {/each}
          </select>
        </div>
        <div class="flex flex-none align-center ">
          {#if visibleOrderItems.length > 1}
            <button
              type="button"
              use:tooltip={t("remove_this_item")}
              on:click={() => handleRemoveItem(item.id)}
              class="px-3 border-0 background-transparent hover:text-red-600">
              <Close width="20" height="20" />
            </button>
          {:else}
            <Tooltip>{t("cant_remove_latest_item")}</Tooltip>
          {/if}
        </div>
      </div>
    {/each}
  </div>
  <div class="t-form-row __center">
    <button
      on:click|preventDefault={saveChanges}
      class="tc-button __size-big __color-primary">
      {t("save_and_continue")}
    </button>
  </div>
{/if}

<!-- <Modal
  visible={mode === "confirm"}
  let:close
  on:close={handleCloseConfirmConversion}
  width="800px">
  <p class="my-8">{@html t("confirmation_description")}</p>

  <div class="flex flex-wrap justify-center gap-4">
    <button
      class="tc-button __size-small __color-primary"
      on:click={close("confirm")}>
      {t("confirm_dialog")}
    </button>

    <a
      class="tc-button __size-small __color-secondary"
      href={urls.edit_order_path}>
      {t("decline_dialog")}
    </a>
  </div>
</Modal> -->
